export default "__VITE_ASSET__BRAiw0LN__"